/* 
 * use const [ snackBarOpen, setSnackBarOpen ] = useState(false)
 * <SnackBar msg=..., type=... /> msg comes from the server where appropriate.
 * SnackBar type:
 *    error
 *    success
 * 
 * Currently called by:
 *    /Components/AddPhotoCollection which is called by /Pages/ManagePhotoCollectionPhotos
 *    /Pages/AddGrad
 *    /Pages/AddPhoto
 *    /Pages/EditOneProfilePage
 *    /Pages/EditPhoto
 *    /Pages/ForgotUsernamePassword
 *    /Pages/Login
 *    /Pages/ManageBioPhotos
 *    /Pages/ManageClassPatches
 *    /Pages/ManageClassPhotos
 *    /Pages/NewAnnouncement
 *    /Pages/PhotoSearch
 *    /Pages/ResetPassword
 *    /Pages/SuperUserAddABio
 *    /Pages/SuperUserResetPassword
 *    /Pages/UpdateGrad
 */

import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function CustomizedSnackbars({ msg, type }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>

      <Alert severity={ type } > { msg } </Alert>

    </div>
  );
}
